export default __webpack_public_path__ + "static/young-bg-1ec5e17ab09df3c4301a6568dced7707.png";